import { defineComponent as _defineComponent } from 'vue'
import { AnalogSensor, AnalogSensorType } from "@duet3d/objectmodel";
import { computed } from "vue";

import i18n from "@/i18n";
import store from "@/store";
import { getExtraColor } from "@/utils/colors";
import { displaySensorValue } from "@/utils/display";

interface ExtraSensor {
    sensor: AnalogSensor;
    index: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExtraSensorList',
  setup(__props) {

const extraSensors = computed<Array<ExtraSensor>>(() => {
    const heaters = store.state.machine.model.heat.heaters;
    return store.state.machine.model.sensors.analog
        .map((sensor, index) => ({
            sensor,
            index
        }))
        .filter(({ sensor, index }) => (sensor !== null) && !heaters.some(heater => (heater !== null) && (heater.sensor === index))) as Array<ExtraSensor>;
});

const displayedExtraTemperatures = computed(() => store.state.machine.settings.displayedExtraTemperatures);

function toggleExtraVisibility(sensor: number) {
    store.commit("machine/settings/toggleExtraVisibility", sensor);
}

const uiFrozen = computed<boolean>(() => store.getters["uiFrozen"]);

function formatExtraName(sensor: { sensor: AnalogSensor, index: number }) {
    if (sensor.sensor.name) {
        const matches = /(.*)\[(.*)\]$/.exec(sensor.sensor.name);
        if (matches) {
            return matches[1];
        }
        return sensor.sensor.name;
    }
    return i18n.t("panel.tools.extra.sensorIndex", [sensor.index]);
}

return { __sfc: true,extraSensors, displayedExtraTemperatures, toggleExtraVisibility, uiFrozen, formatExtraName, getExtraColor, displaySensorValue }
}

})